<template>
  <div class="flex h-screen min-w-0 overflow-hidden overflow-x-hidden">
    <!-- 主内容区域 -->
    <div class="flex-1 min-w-0 flex flex-col bg-gray-100 overflow-hidden overflow-x-hidden">
      <!-- 头部 -->
      <div class="h-15 bg-blue-900 bg-opacity-85 flex justify-between items-center px-5 shadow-md z-50 text-blue-100">
        <!-- 左侧标题 -->
        <div class="flex items-center space-x-4">
          <div class="platform-title mr-5">
            <h3 class="text-white font-bold text-lg whitespace-nowrap">
              数据管理
            </h3>
          </div>
        </div>

        <!-- 右侧用户信息 -->
        <div class="flex items-center space-x-3">
          <span class="text-blue-100 text-sm">
            {{ username }}
          </span>
          <el-button 
            type="text" 
            size="small" 
            @click="logout"
            class="text-blue-100 hover:text-white"
          >
            退出登录
          </el-button>
        </div>
      </div>

      <!-- 主体内容 -->
      <div class="flex-1 overflow-auto flex flex-col">
        <!-- 数据管理按钮组 -->
        <div class="bg-white border-b border-gray-200 px-6 py-3 shadow-sm">
          <div class="flex items-center space-x-2 overflow-x-auto">
            <el-button
              :type="currentDataManagementType === 'history' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentDataManagementType === 'history' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleDataManagementMenuClick('history')"
              size="small"
            >
              <i class="el-icon-time"></i>
              <span>桥梁检测</span>
            </el-button>
            <!-- 预留其他按钮位置 -->
          </div>
        </div>
        
        <!-- 内容区域 -->
        <div class="flex-1 overflow-auto">
          <slot></slot>
        </div>
      </div>
      
      <!-- 底部 -->
      <div class="h-10 bg-blue-900 bg-opacity-85 flex justify-center items-center text-blue-100 text-xs border-t border-opacity-20 border-blue-300">
        <p>© 2025 桥卫士</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataManagementLayout',
  data() {
    return {
      username: localStorage.getItem('username') || '用户'
    }
  },
  computed: {
    currentDataManagementType() {
      const path = this.$route.path;
      if (path.startsWith('/data-management/')) {
        return path.replace('/data-management/', '');
      }
      return 'history';
    },
    currentDataManagementMenuText() {
      const menuMap = {
        'history': '桥梁检测'
      };
      return menuMap[this.currentDataManagementType] || '数据管理';
    }
  },
  methods: {
    handleDataManagementMenuClick(command) {
      const target = `/data-management/${command}`;
      // 已在目标页面时不再重复导航，避免抛出 NavigationDuplicated
      if (this.$route.path === target) {
        return;
      }
      this.$router.push(target).catch(() => {});
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
/* 按钮组样式优化 */
.el-button--small {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.el-button--small i {
  margin-right: 4px;
}
</style>

